(function () {
    'use strict';

    angular
        .module('salesflare')
        .config(function ($mdDialogProvider) {

            $mdDialogProvider.addPreset('viewCreditUsageDialog', {
                // @ngInject
                options: function ($mdMedia) {
                    return {
                        fullscreen: !$mdMedia('gt-sm'),
                        templateUrl: 'app-ajs/components/viewCreditUsageDialog/viewCreditUsageDialogTemplate.html',
                        controllerAs: 'vm',
                        controller: viewCreditUsageDialogController,
                        bindToController: true,
                        clickOutsideToClose: true,
                        escapeToClose: true,
                        multiple: true
                    };
                }
            });

            /*
             * Annotate the function so uglyfying (more specifically mangling) the file doesn't break it.
             * @ngInject
             */
            function viewCreditUsageDialogController($mdDialog, $mdMedia, $rootScope, $translate, themeService) {

                const vm = this;

                vm.$mdMedia = $mdMedia;

                vm.$onInit = () => {

                    const startDate = moment(vm.historical_team_credit_usage[vm.historical_team_credit_usage.length - 1].start_date).format('MMM D');
                    const endDate = moment(vm.historical_team_credit_usage[vm.historical_team_credit_usage.length - 1].end_date).format('MMM D');
                    vm.currentMonthHeader = $translate.instant('This month\'s usage ({{startDate}} - {{endDate}})', { startDate, endDate });

                    const monthLabels = [
                        $translate.instant('11m ago'),
                        $translate.instant('10m ago'),
                        $translate.instant('9m ago'),
                        $translate.instant('8m ago'),
                        $translate.instant('7m ago'),
                        $translate.instant('6m ago'),
                        $translate.instant('5m ago'),
                        $translate.instant('4m ago'),
                        $translate.instant('3m ago'),
                        $translate.instant('2m ago'),
                        $translate.instant('Last month'),
                        $translate.instant('This month')
                    ];
                    const chartJsColorObject = {
                        backgroundColor: '#303c4f',
                        pointBackgroundColor: '#303c4f',
                        pointHoverBackgroundColor: '#303c4f',
                        borderColor: '#303c4f',
                        pointBorderColor: '#fff',
                        pointHoverBorderColor: '#303c4f'
                    };

                    const theme = themeService.get();

                    let gridLineColor = 'rgba(0, 0, 0, 0.12)';

                    if (theme === 'dark') {
                        gridLineColor = '#4f4f4f';
                    }

                    vm.chartData = vm.historical_team_credit_usage.map((dataPoint) => {

                        return dataPoint.usage;
                    });
                    vm.chartLabels = vm.historical_team_credit_usage.map((dataPoint, index) => {

                        return monthLabels[monthLabels.length - vm.historical_team_credit_usage.length + index];
                    });
                    vm.chartDatasetOverride = {
                        lineTension: 0,
                        fill: false,
                        ...chartJsColorObject
                    };
                    vm.chartOptions = {
                        maintainAspectRatio: false, // Needed to fill up our chart container fully.
                        tooltips: {
                            titleFontFamily: '\'Source Sans 3\', \'sans-serif\'',
                            bodyFontFamily: '\'Source Sans 3\', \'sans-serif\'',
                            enabled: true,
                            mode: 'single'
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    fontFamily: '\'Source Sans 3\', \'sans-serif\'',
                                    beginAtZero: true
                                },
                                gridLines: {
                                    color: gridLineColor,
                                    zeroLineColor: gridLineColor
                                }
                            }],
                            xAxes: [{
                                ticks: {
                                    fontFamily: '\'Source Sans 3\', \'sans-serif\''
                                },
                                gridLines: {
                                    display: false
                                }
                            }]
                        }
                    };
                    // Add the colors for each data point
                    vm.chartColors = vm.historical_team_credit_usage.map(() => {

                        return chartJsColorObject;
                    });
                };

                vm.cancel = $mdDialog.cancel;
            }
        });
})();
